/**
 * Tiny privacy-light telemetry: in-memory ring of named events the
 * dev console can inspect, plus a beacon hook for sending to whatever
 * analytics backend the platform later wires in.
 *
 * No PII, no IP capture, no fingerprinting. Just `{ name, at, props? }`
 * so we can answer "is anyone using the search panel?" once we ship
 * to real users.
 */

type Event = { name: string; at: number; props?: Record<string, unknown> };

const buf: Event[] = [];
const MAX = 200;
let beacon: ((event: Event) => void) | null = null;

export function setTelemetryBeacon(fn: ((event: Event) => void) | null): void {
  beacon = fn;
}

export function track(name: string, props?: Record<string, unknown>): void {
  const event: Event = props ? { name, at: Date.now(), props } : { name, at: Date.now() };
  buf.push(event);
  if (buf.length > MAX) buf.shift();
  try {
    beacon?.(event);
  } catch {
    /* ignore beacon errors */
  }
}

export function recentEvents(): Event[] {
  return buf.slice();
}

if (typeof window !== 'undefined') {
  (window as unknown as { __appDiag?: () => Event[] }).__appDiag = recentEvents;
}
